import React, { useRef } from 'react';
import { Box, Grid, Popover } from '@mui/material';

import { NavItem } from '.';

export interface PopupProps {
  items: Array<{ id: number; label: string; onClick: Function; icon?: any; prependIcon?: boolean }>;
  children?: React.ReactNode;
  width?: number;
  onClose?: Function;
}

export const Popup: React.FC<PopupProps> = (props) => {
  const containerRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { items, children, width = 120, onClose = () => {} } = props;

  const handleClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box ref={containerRef}>
      <Box
        onClick={(event: any) => {
          handleClick(event);
        }}
      >
        {children}
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ marginTop: 1 }}
        PaperProps={{ style: { boxShadow: '0px 0px 8px rgb(0 0 0 / 24%)' } }}
        container={containerRef.current}
      >
        <Grid container spacing={0.4} sx={{ width, padding: 0.6 }}>
          {items.map((item) => (
            <Grid key={`add-bzd-menu-option-${item.id}`} item xs={12}>
              <NavItem
                label={item.label}
                icon={item.icon}
                prependIcon={item.prependIcon}
                onClick={() => {
                  item.onClick();
                  handleClose();
                }}
                style={{ width: '100%', justifyContent: 'flex-end', paddingX: 1, paddingY: 0.5, borderRadius: 1 }}
              />
            </Grid>
          ))}
        </Grid>
      </Popover>
    </Box>
  );
};
